import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; 
import '../styles/App.scss';
import { useSelector, useDispatch } from 'react-redux';
import { clearGlobalDataAfterBuy, setCupon, setHayNbps } from '../globalslice';
import { clearProfileDataAfterBuy } from '../slices/profileSlice';
import Swal from 'sweetalert2'

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import CartListItem from './CartListItem';
import CartListHeader from './CartListHeader';
import LoginBase from './Login/LoginBase'
import { AuthContext } from '../Auth';

import ListPaymentMethod from './Checkout/ListPaymentMethod'
import { ThemeProvider } from '@mui/material/styles';
import nbxTheme from './themes/nbxTheme';
import { ReactComponent as TrashWhite } from '../images/trash-white.svg';
import { ReactComponent as Trash } from '../images/trash.svg';
import CartSteps from './CartSteps';
import interrogationImg from '../images/interrogation.svg'

import { useTranslation } from 'react-i18next';
import DrawerBodyEmpty from './Header/DrawerCartSummary/DrawerBodyEmpty';
import { fetchClearCart } from '../services/SearchDomain';

export default function CartDetails() {
  const [isHovered, setIsHovered] = useState(false);
  const { userAuth } = useContext(AuthContext);
  const ResumenData = useSelector(state => state.global.ResumenData);
  const msg = useSelector(state => state.global.hayNbps);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const countActualTrue = ResumenData.filter((item) => item.actual === false).length;

  const handleClear = () => {
    Swal.fire({
      title: t("swal.cart.uSure"),
      text:  t("swal.cart.clear"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t("swal.cart.confirm"),
      cancelButtonText: t("swal.cart.cancel"),
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn-red',
    },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(clearProfileDataAfterBuy());
        dispatch(clearGlobalDataAfterBuy());
        dispatch(setCupon(''));
        fetchClearCart()
        dispatch(setHayNbps());
        Swal.fire({
          title: t("swal.cart.success"),
          text: t("swal.cart.clearCart"),
          icon: 'success',
          confirmButtonText: 'OK',
        });

        // eliminación de elementos de cookies
        if (typeof window.NBXDomainInCart !== "undefined") {
          const domainsCart = window.NBXDomainInCart.getAll();

          if (typeof window.NBXDeletedDomainCart !== "undefined") {
            domainsCart.forEach((item) => {
              // agregamos los dominios a eliminar en v4
              window.NBXDeletedDomainCart.add(item.domain)
            });
          }

          if (typeof window.NBXDeletedDomain !== "undefined") {
            // eliminación de dominios eliminados de v4
            window.NBXDeletedDomain.deleteAll();
          }

          // se eliminan las cookies de dominios agregados al carrito
          window.NBXDomainInCart.deleteAll();
        }
      }
    });
  };

  const card = (
    <React.Fragment>
      <CartListHeader />
      { countActualTrue ?
        <List>
      {ResumenData.filter(item => item.actual === false).map((item, index, filteredData) => (
          <React.Fragment key={item.id}>
            <ListItem>
              <CartListItem data={item} ResumenData={ResumenData}/>
            </ListItem>
            {index < filteredData.length - 1 && (
              <Divider
                className='divider-custom'
              />
            )}
          </React.Fragment>
        ))}
       {(msg == 'nbps' || msg == 'nbpsT') && (
          <ListItem>
            <div style={{ color: 'red', fontSize: '1.5em', marginBottom: '16px' }}>
              <div className='disclaimer'>
                <img src={interrogationImg} alt="question icon" height="14px" width="14px"/>
                <p dangerouslySetInnerHTML={{ __html: t("myCart.disclaimernbps") }}></p>
              </div>
            </div>
          </ListItem>
        )}
      </List> 
      : <DrawerBodyEmpty />
      }
    </React.Fragment>
  );

  return (
    <div className="col-md-7 col-sm-12 col-xs-12 cf-content">
      <ThemeProvider theme={nbxTheme}>

        <CartSteps numberStep={2} />

        <div style={{ fontSize: '2em', marginTop: 32 }}>{t("myCart.title")}</div>
        <Box sx={{ minWidth: 275 }}>
          <Card variant="outlined">{card}</Card>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          
          {countActualTrue ?
          <Button
            sx={{
              textTransform: 'none',
              fontFamily: 'Patua one',
              '&:hover': {
                backgroundColor: '#D32F2F',
                color: 'white',
              },
            }}
            onClick={handleClear}
            color="error"
            variant="outlined"
            startIcon={isHovered ? <TrashWhite sx={{ color: 'inherit' }} /> : <Trash sx={{ color: 'inherit' }} />}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {t("myCart.clearCartbtn")}
          </Button>: null
          }
        </Box>
          <div style={{ fontSize: '2em', marginTop: 16 }}>{userAuth ? t("signUp.titleLogedin") : t("signUp.title")}</div>
          <div className='cart-subtitle '>{userAuth ? '' :  t("signUp.subtitle")}</div>
          <LoginBase></LoginBase>
          <div style={{ fontSize: '2em', marginTop: 32 }}>{t("listPayments.title")}</div>
          <div className='cart-subtitle '> {t("listPayments.subtitle")}</div>
          <ListPaymentMethod></ListPaymentMethod>
        </Box>
      </ThemeProvider>
    </div>
  );
};